export default __webpack_public_path__ + "static/media/fronius.97113f05.png";